'use client';
import { useEffect, useState } from 'react';
import { useSiteFlags } from '@/context/SiteFlagsContext';
import { getOrCreateSessionId } from '@/utils/session-manager';
import { assignWizardVariant, type WizardVariant } from '@/lib/wizard/fast-path';
import { track } from '@/utils/analytics';

/**
 * The visitor's wizard arm. Starts as 'control' and not ready (identical server and first client render,
 * so no hydration mismatch). Assigns once on mount, stable per session id, and records the arm in Umami
 * while the experiment is on.
 */
export function useWizardVariant(override: string | null | undefined): { variant: WizardVariant; ready: boolean } {
  const { fastPathWizard, fastPathWizardRollout } = useSiteFlags();
  const [state, setState] = useState<{ variant: WizardVariant; ready: boolean }>({ variant: 'control', ready: false });

  useEffect(() => {
    let visitorId: string | null = null;
    try { visitorId = getOrCreateSessionId(); } catch { visitorId = null; }
    const variant = assignWizardVariant({ enabled: fastPathWizard, rolloutPercent: fastPathWizardRollout, visitorId, override });
    setState({ variant, ready: true });
    if (fastPathWizard) track(variant === 'fast' ? 'wizard_variant_fast' : 'wizard_variant_control');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return state;
}
